module.exports = __webpack_public_path__ + "img/info-5.cc2bcf3b.svg";